import React, { useEffect, useState } from 'react'
import Layout from './layout'
import Subpages from './public/subpages'
import { getAboutShow } from '../api/api'
import moment from 'moment'

const Ltgk = () => {
  const [data, setData] = useState({})

  useEffect(() => {
    getAboutShow().then(res => {
      setData(res.data)
    })
  }, [])

  return (
    <Layout>
      <Subpages hidden="hidden" className="px-5 lg:px-0 mb-10 lg:mb-0" name="论坛概况">
        <div className="">
          <h1 className="mt-10 text-center text-[#333333] text-[26px] font-alhpr font-bold">
            {data?.title}
          </h1>
          <h2 className="text-center text-[#333333] font-alhpr font-bold mt-2">{data?.titles}</h2>
          <p className="text-center text-[#999999] font-alhpr mt-2">
            {data?.price} 发布日期：{moment(data?.publishtime * 1000).format('YYYY-MM-DD')}
          </p>
          <hr className="my-8" />
          <div dangerouslySetInnerHTML={{ __html: data?.content }} />
          <hr className="my-8" />
        </div>
      </Subpages>
    </Layout>
  )
}

export default Ltgk
